import { Component, ViewChild } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalComponent } from '@coreui/angular-pro';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ValidationService } from '../../service/validation.service';
import { PermissionAgreementService } from "src/app/shared/service/permission-agreement.service";
import { NgxSpinnerService } from 'ngx-spinner';
import { HttpErrorResponse } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'password-dialog',
  templateUrl: './password-dialog.component.html',
  styleUrls: ['./password-dialog.component.scss'],
  providers: [PermissionAgreementService]
})
export class PasswordDialogComponent {

  @ViewChild('passwordDialog') passwordDialog: ModalComponent | undefined;

  //FORM GROUP
  public form !: FormGroup;
  //FORM
  public password  !: AbstractControl;

  constructor(
    private validationService         : ValidationService,
    private activeModal               : NgbActiveModal,
    private formBuilder               : FormBuilder,
    private permissionAgreementService: PermissionAgreementService,
    private spinnerService            : NgxSpinnerService,
    private toastr                    : ToastrService,
  ) { }

  ngOnInit() {
    this.buildForm();
  }

  /**
   * Montagem do formulário
   * @memberof PasswordDialogComponent
   */
  buildForm(): void {    
    this.form = this.formBuilder.group({
      password     : ['', Validators.compose([Validators.required])]
    });

    this.password = this.form.controls['password'];
  }

  public getData() {
    return {
      "password": this.password.getRawValue(),
      "browser" : this.getBrowserName() + " " + this.getBrowserVersion(),
      "so"      : this.getSO()
    }
  }

  getBrowserName() {
    const agent = window.navigator.userAgent.toLowerCase();
    switch (true) {
      case agent.indexOf('edge') > -1:
        return 'edge';
      case agent.indexOf('opr') > -1 && !!(<any>window).opr:
        return 'opera';
      case agent.indexOf('chrome') > -1 && !!(<any>window).chrome:
        return 'chrome';
      case agent.indexOf('trident') > -1:
        return 'ie';
      case agent.indexOf('firefox') > -1:
        return 'firefox';
      case agent.indexOf('safari') > -1:
        return 'safari';
      default:
        return 'other';
    }
  }

  getBrowserVersion() {
    const userAgent: any = navigator.userAgent;
    let tempMatch: any;
    let versionMatch: any =
      userAgent.match(
        /(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i
      ) || [];
    if (/trident/i.test(versionMatch[1])) {
      tempMatch = /\brv[ :]+(\d+)/g.exec(userAgent) || [];
      return 'IE ' + (tempMatch[1] || '');
    }
    if (versionMatch[1] === 'Chrome') {
      tempMatch = userAgent.match(/\b(OPR|Edge)\/(\d+)/);
      if (tempMatch != null) {
        return tempMatch.slice(1).join(' ').replace('OPR', 'Opera');
      }
    }
    versionMatch = versionMatch[2]
      ? [versionMatch[1], versionMatch[2]]
      : [navigator.appName, navigator.appVersion, '-?'];
    if ((tempMatch = userAgent.match(/version\/(\d+)/i)) != null)
      versionMatch.splice(1, 1, tempMatch[1]);
    return versionMatch;
  }

  getSO() {
    var OSNome = "";
    if (window.navigator.userAgent.indexOf("Windows NT 10.0")!= -1) OSNome="Windows 10";
    if (window.navigator.userAgent.indexOf("Windows NT 6.2") != -1) OSNome="Windows 8";
    if (window.navigator.userAgent.indexOf("Windows NT 6.1") != -1) OSNome="Windows 7";
    if (window.navigator.userAgent.indexOf("Windows NT 6.0") != -1) OSNome="Windows Vista";
    if (window.navigator.userAgent.indexOf("Windows NT 5.1") != -1) OSNome="Windows XP";
    if (window.navigator.userAgent.indexOf("Windows NT 5.0") != -1) OSNome="Windows 2000";
    if (window.navigator.userAgent.indexOf("Mac")            != -1) OSNome="Mac/iOS";
    if (window.navigator.userAgent.indexOf("X11")            != -1) OSNome="UNIX";
    if (window.navigator.userAgent.indexOf("Linux")          != -1) OSNome="Linux";
    
    return OSNome;
  } 

  public decline() {
    this.activeModal.close(false);
  }

  public accept() {
    if (this.form.valid) {
      this.spinnerService.show();
      this.permissionAgreementService.getPermission(this.getData())
        .subscribe({ 
          next: (response: any) => {
            if (response.code == 0) {
              this.activeModal.close(true);
            } else {
              this.toastr.warning("Senha inválida.", "Aviso!")
            }
            this.spinnerService.hide();
          },
          error: (erro: HttpErrorResponse) => { 
            this.toastr.error("Ocorreu uma falha ao autenticar: [" + erro?.message?.replace(environment.API_BASE_URL_REGULATION_AUTO, '') + "].", "Erro")
            this.spinnerService.hide();
          }
        }); 
    } else {
      this.toastr.warning("Por favor informar a senha.", "Aviso!")
    }   
  }

  public dismiss() {
    this.activeModal.dismiss();
  }

  /**
   * 
   * @param {AbstractControl} control
   * @returns 
   */
  errorMessage(control: AbstractControl) {
    return this.validationService.errorMessage(control);
  }
}
